var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnHoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1852 34.4109H32.24L32.6677 37.1737L32.6678 37.1745C32.709 37.443 32.7286 37.7132 32.7286 37.9833C32.7286 38.9655 32.4119 40.0333 31.9108 40.8656C31.4292 41.6654 30.6582 42.4298 29.672 42.4298C29.3233 42.4298 28.9795 42.3396 28.6748 42.163C28.4753 42.0474 28.3597 41.8276 28.3775 41.5977L28.6239 38.4088C28.6548 38.0068 28.5591 37.6055 28.3501 37.2624C28.3447 37.2535 28.3395 37.2444 28.3345 37.2352L25.3207 31.6497L24.4975 30.9438C24.3646 30.8298 24.2881 30.6634 24.2881 30.4883V22.4357C24.2881 22.2002 24.4259 21.9865 24.6404 21.8892L24.8238 21.8061C24.9469 21.748 25.0592 21.674 25.1568 21.5864C25.1675 21.5768 25.1786 21.5675 25.19 21.5587C25.8202 21.0706 26.5862 20.7896 27.3842 20.7561C27.3926 20.7557 27.401 20.7556 27.4094 20.7556H36.1232C36.1359 20.7556 36.1486 20.756 36.1613 20.7568C36.8719 20.8019 37.5118 21.2021 37.8624 21.8227C38.1971 22.4116 38.2256 23.1219 37.948 23.7329C38.619 23.8863 39.1777 24.3602 39.4358 25.0046L39.436 25.0051C39.6941 25.6512 39.6157 26.3796 39.2342 26.9536C39.9763 27.2341 40.5036 27.9094 40.5879 28.7065C40.6732 29.5006 40.302 30.2702 39.6398 30.7005C40.1022 31.0944 40.3744 31.6738 40.3744 32.289C40.3744 32.8409 40.1507 33.3666 39.7598 33.7501C39.3444 34.169 38.7805 34.4072 38.1889 34.4109V34.4109H38.1852Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.031 32.4145C18.0148 32.4145 18.0013 32.4024 18 32.3848V20.5396C18.0013 20.5235 18.0148 20.51 18.031 20.51H24.8539C24.8714 20.51 24.8862 20.5221 24.8876 20.5396V26.4616V32.3848C24.8862 32.4024 24.8714 32.4145 24.8539 32.4145H18.031Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1759 29.3587C23.1759 30.1017 22.5718 30.7055 21.8291 30.7055C21.0864 30.7055 20.4823 30.1017 20.4823 29.3587C20.4823 28.6158 21.0864 28.0119 21.8291 28.0119C22.5718 28.0119 23.1759 28.6158 23.1759 29.3587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHoldIcon);
export default __webpack_public_path__ + "static/media/onHoldIcon.a6c2cc00147c8ebea4e755dc9f4ca43b.svg";
export { ForwardRef as ReactComponent };